// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"3b362a12","787":"d1afb777","850":"6898de1d","902":"20c39cde"}[chunkId] + ".chunk.js";
};